import { FormattedMessage } from 'react-intl';

import { LockoutModal, LockoutModalProps } from './lockout-modal.component';

type PinCodeLockoutModalProps = Omit<LockoutModalProps, 'title' | 'description'>;

export const PinCodeLockoutModal = (props: PinCodeLockoutModalProps) => {
    return (
        <LockoutModal
            {...props}
            title={
                <FormattedMessage
                    id='kiosk.wizard.pin-code.too-many-attempts'
                    defaultMessage='Too many attempts'
                    description='Title for too many PIN attempts modal'
                />
            }
            description={
                <FormattedMessage
                    id='kiosk.wizard.pin-code.wait-message'
                    defaultMessage='You have exceeded the maximum number of attempts. Please wait before trying again.'
                    description='Message explaining user must wait'
                />
            }
        />
    );
};
